module.exports = __webpack_public_path__ + "static/img/正面透明底倒影.076c8ebe.png";